import { AuthService } from 'src/app/core/auth/auth.service';
import { Router } from '@angular/router';
import { MainMenuService } from 'src/app/shared/services/mainmenu.service';
import { Action, GotoAction } from 'src/app/shared/models/action';
import { GeneralService } from 'src/app/shared/services/general.service';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthState } from '../core/auth/auth-state';

@Injectable({
    providedIn: 'root'
})
export class SharedController {

    private mainList = [];

    protected companiesSubscription: Subscription;
    protected companieSelSubscription: Subscription;

    constructor(
        protected mms: MainMenuService,
        protected route: Router,
        protected auth: AuthService,
        protected gs: GeneralService) {

        this.auth.getAuthStateChange().subscribe(result => {
            if (result.state === AuthState.SIGNED_OUT) {
                this.gs.setCompaniesList(false, []);
                this.loadButtons();
            }
            if (result.state === AuthState.SIGNED_IN) {
                //this.loadButtons();
            }
        });
        this.gs.userdata$.subscribe(result => {
            this.loadButtons();
        });

    }

    public loadButtons() {
        this.mms.updateButtons(this.getMainMenu().concat(this.auth.getDefaultAction()));
    }

    setMainMenu(list) {
        this.mainList = list;
    }

    private getMainMenu(): Action[] {

        let menu = [];
        let list = this.gs.getCompaniesList();

        if (!!list?.invite?.length)
            menu.push(new GotoAction('user_account_invite', 'Convites de acesso', ['account'], { main: true, icon: "heart", badge: list?.invite?.length }, this.route));

        list?.accept
            ?.sort((a, b) => a?.name.localeCompare(b?.name))
            ?.map(item => {
                menu.push(new GotoAction('user_account', item.name, ['builder', 'dashboard', item.company_person_id], { main: true, icon: "heart", avatarFile: item?.avatarFile }, this.route))

            });//item.company_perfil_id =='6'? 'realestate' : 

        if (!!menu.length)
            this.mainList = this.mainList.concat(menu);

        return this.mainList.concat(this.gs.getMenu(this.gs.getBase().replace('/', ''), this.route, { builder: !!list?.accept?.length || !!list?.invite?.length }));

    }
}